export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/software-license-management/software-license-management.controller.js